import { API_URL, Status } from '../constants';
import { fetch } from '../fetchWrapper/fetch';

export const deleteVenueCategory = async (categoryId: string): Promise<void> => {
  const res = await fetch(`${API_URL}/venues/categories/${categoryId}`, {
    method: 'DELETE',
  });

  if (res.status !== Status.NO_CONTENT) {
    throw new Error('Failed to delete venue category');
  }
};
